// extracted by mini-css-extract-plugin
export default {"caixona":"p6_caixona__GqaqM","caixa":"p6_caixa__lHiQO"};